<div class="auth-container">
  <h2>Join Bacon Arcade</h2>
  <p class="subtitle">Level up your gaming experience</p>

  <button class="sign_in btn" (click)="login()">Sign in</button>

  <app-terms></app-terms>
</div>
